export const handleSetInstance = (id, data, setData) => {
  const instance = data.qrcodes.filter(item => (item._id === id))
  setData(instance[0])
}

export const getActive = (id, data) => {
  const instance = data.qrcodes.filter(item => (item._id === id))  
  if(instance.length === 0) return false
  return instance[0].active
}

export const MUIColumns = (t, customBodyRenderActions) => {
  return [
    {
      name: "name", label: t("qrcode_table_name_column"),
      options: {
        filter: true, sort: true,
        customHeadLabelRender: (columnMeta) => <b>{columnMeta.label}</b>
      }
    },
    {
      name: "menu_data", label: t('qrcode_table_menu_column'),
      options: {
        filter: true, sort: true,
        customHeadLabelRender: (columnMeta) => <b>{columnMeta.label}</b>,
        customBodyRender: (value, tableMeta, updateValue) => value.name
      }
    },
    {
      name: "_id", label: t('menu_table_actions_column'),
      options: {
        filter: false, sort: false, download: false,
        customHeadLabelRender: (columnMeta) => <b>{columnMeta.label}</b>,
        customBodyRender: customBodyRenderActions
      }
    },
  ]
}